<template>
    <div>
        <card>
            <card-header><strong>Subscribe</strong></card-header>
            <card-body v-if="loading">
                <card-spinner class="mt-3" style="height: 100px"></card-spinner>
            </card-body>
            <select-stripe-plans :plans="availablePlans" :plan-id.sync="form.plan"
                                 :locations-limit.sync="form.locations_limit" v-if="!loading"></select-stripe-plans>
        </card>
        <card v-show="form.plan">
            <card-header>Billing Information</card-header>
            <card-body>
                <div class="alert alert-danger" v-if="form.errors.has('form')">We had trouble validating your card. It's
                    possible your card provider is preventing us from charging the card. Please contact your card
                    provider or customer support.
                </div>
                <div class="alert alert-danger" v-if="form.errors.hasErrors()"><b>Please verify the following
                    errors:</b>
                    <ul class="mb-0">
                        <li v-for="error of form.errors.all()" :key="error">{{ error[0] }}</li>
                    </ul>
                </div>
                <div class="form-group row" v-if="hasPaymentMethod()"><label
                        class="col-md-4 col-form-label text-md-right">Payment Method</label>
                    <div class="col-md-6"><select class="form-control" v-model="form.use_exiting_payment_method">
                        <option value="1">Use existing payment method</option>
                        <option value="0">Use a different method</option>
                    </select></div>
                </div>
                <div v-show="form.use_exiting_payment_method !== '1'">
                    <div class="form-group row"><label class="col-md-4 col-form-label text-md-right">Cardholder's
                        Name</label>
                        <div class="col-md-6"><input class="form-control" v-model="cardForm.name"/></div>
                    </div>
                    <div class="form-group row"><label class="col-md-4 col-form-label text-md-right">Card</label>
                        <div class="col-md-6">
                            <div id="subscription-card-element"></div>
                            <span class="invalid-feedback" v-if="cardForm.errors.has('card')">{{ cardForm.errors.get('card') }}</span>
                        </div>
                    </div>
                </div>
                <div class="form-group row" v-if="! spark.collectsBillingAddress"><label
                        class="col-md-4 col-form-label text-md-right">ZIP / Postal Code</label>
                    <div class="col-md-6"><input class="form-control" v-model="form.zip"/></div>
                </div>
                <div class="form-group row"><label class="col-md-4 col-form-label text-md-right">Coupon</label>
                    <div class="col-md-6">
                        <input-text class="mb-0" v-model="form.coupon" field="coupon" :form="form"></input-text>
                    </div>
                </div>
                <div class="form-group row mb-0">
                    <div class="col-md-6 offset-md-4">
                        <button-loading class="btn btn-primary" @click.prevent="subscribe" :loading="form.busy">
                            Subscribe
                        </button-loading>
                    </div>
                </div>
            </card-body>
        </card>
    </div>
</template>

<script>
    export default {
        mixins: [
            require('settings/subscription/subscribe-stripe'),
        ],

        data() {
            return {
                form: new SparkForm({
                    use_exiting_payment_method: this.hasPaymentMethod() ? '1' : '0',
                    stripe_token: '',
                    plan: '',
                    coupon: null,
                    address: '',
                    address_line_2: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: 'US',
                    vat_id: '',
                    locations_limit: this.team.locations_limit
                }),
                availablePlans: [],
                loading: true,
                stripePlans: [],
            };
        },

        computed: {
            urlForNewSubscription() {
                return this.$laroute.route('api.teams.subscribe', {team: this.team.id});
            },
        },

        created() {
            this.fetchPlans();
        },

        methods: {
            fetchPlans() {
                return this.$http
                    .get(this.$laroute.route('api.plans.index'))
                    .then(response => {
                        this.loading = false;
                        this.stripePlans = response.data.data;
                        this.availablePlans = this.filteredByAvailablePlans(this.stripePlans);
                        // this.afterFetchPlans();
                    });
            },

            filteredByAvailablePlans(plans) {
                const availablePlans = this.team.available_plans.length ? this.team.available_plans : [
                    DevSquad.swellPlanBasic, DevSquad.swellPlanAdvanced
                ];

                return plans.filter(plan => availablePlans.includes(plan.id));
            },
        }
    };
</script>
